import { useMutation } from "@tanstack/react-query"

import { useClient } from "api"

import type { OnboardingInfoResponse, PutPersonRequest } from "../types"

const usePutPerson = () => {
  const { post } = useClient()

  return useMutation({
    mutationFn: async (request: PutPersonRequest): Promise<OnboardingInfoResponse> =>
      post<PutPersonRequest, OnboardingInfoResponse>("Patients/put-person", request),
  })
}

export { usePutPerson }
